import styled from "styled-components";

const Container = styled.div`
    padding: 150px 0 100px 0;
`;

const Title = styled.h3`
  font-size: 24px;
  margin-bottom: 32px;
`;
export const Paragraph = styled.p`
  margin: 24px 0;
`;
export const H2 = styled.p`
  margin: 24px 0;
  font-size: 24px;
`;

function SinglePage({ children, title }) {


    return <Container>
        <Title>{title}</Title>
        {children}
    </Container>
}

export default SinglePage;
